import { unified }        from 'unified'
import remarkParse        from 'remark-parse'
import remarkGfm         from 'remark-gfm'
import remarkRehype      from 'remark-rehype'
import rehypeHighlight   from 'rehype-highlight'
import rehypeReact       from 'rehype-react'
import { Fragment, jsx, jsxs } from 'react/jsx-runtime'
import type { ReactElement, ComponentType } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ComponentMap = Record<string, ComponentType<Record<string, any>>>

/**
 * Transforms raw markdown into a React element tree using the unified pipeline.
 * Components map allows full Tailwind-styled overrides for every HTML element.
 */
export function renderMarkdown(
  content:    string,
  components: ComponentMap
): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result = unified()
    .use(remarkParse)
    .use(remarkGfm)
    .use(remarkRehype)
    .use(rehypeHighlight)
    // The rehype-react v8 options type doesn't perfectly align with unified's generic Plugin signature
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .use(rehypeReact as any, { Fragment, jsx, jsxs, components })
    .processSync(content)
    .result

  return result as ReactElement
}
